import React from "react";
import CommonRow from "../common-row";
const SixStories1AdWithTagSearch = props => {
  return <CommonRow {...props} />;
};

export default SixStories1AdWithTagSearch;
